export default __webpack_public_path__ + "static/cupping-500bd4796c3a4accf8d27f6e815a1388.jpeg";